import {RecommendedActions, RecommendedActionsJSON} from '../types/RecommendedActionsTypes';

export default class RecommendedActionsSerializer {
  static toObject(payload: RecommendedActionsJSON): RecommendedActions {
    return payload.employee_recommendations.map((action) => {
      return action;
    });
  }
}
